module.exports = __webpack_public_path__ + "static/media/b02.0e037a13.png";